import React, { useEffect, useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
import Options from "../../components/materials/Options";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../lib/axios";
import { Link } from "react-router-dom";
import Delete from "../../components/Delete";
import { showCreateForm } from "../../redux/features/materialSlice";
import EditMaterial from "../../components/materials/EditMaterial";
import Select from "react-select";
import { debounce } from "lodash";

function MaterialList() {
  const [materials, setMaterials] = useState([]);
  const deleteItem = useSelector((state) => state.delete.item);
  const editObj = useSelector((state) => state.material.editObj);
  const createForm = useSelector((state) => state.material.createForm);
  const [categories, setCategories] = useState([
    { name: "همه", active: false, en: "all" },
    { name: " موجودی ها", active: true, en: "exist" },
    { name: "ختم شده ها", active: false, en: "finished" },
  ]);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState(10);
  const [url, setUrl] = useState(`/api/materials`);
  const [tCategories, setTCategories] = useState([]);
  const [tCategory, setTCategory] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    getTCategories();
  }, []);

  useEffect(() => {
    if (!deleteItem.id && !createForm && !editObj) {
      getMaterials();
    }
  }, [categories, deleteItem, records, url, tCategory, createForm, editObj]);

  const delayedSearch = debounce(() => {
    getMaterials();
    console.log("workingg");
  }, 5000);

  useEffect(() => {
    let delaySearch;
    const handleSearchDelay = () => {
      delaySearch = setTimeout(() => {
        console.log(`Performing search for: ${search}`);
        getMaterials();
      }, 800);
    };
    const handleKeyUp = () => {
      if (delaySearch) {
        clearTimeout(delaySearch);
      }
      handleSearchDelay();
    };
    handleKeyUp();
    return () => {
      clearTimeout(delaySearch);
    };
  }, [search]);

  const getTCategories = () => {
    axios.get(`/api/settings/material/category/select2`).then((data) => {
      setTCategories(data);
    });
  };

  const getMaterials = () => {
    axios
      .post(url, {
        category: categories.find((row) => row.active === true).en,
        search,
        records,
        tCategory,
      })
      .then((data) => {
        setMaterials(data);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateCategory = (index) => {
    setCategories((prevCategories) => {
      const updatedCategories = prevCategories.map((row, i) => {
        if (index === i) {
          return { ...row, active: true };
        }
        return { ...row, active: false };
      });

      return updatedCategories;
    });
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row bg-slate-50 border justify-between py-2 px-4">
        <h3>لیست خریداری مواد خام</h3>
        <div className="flex gap-6 ">
          {categories.map((row, index) => (
            <button
              key={index}
              onClick={() => updateCategory(index)}
              className={` rounded-sm  border border-blue-300 px-2 ${
                row.active
                  ? "bg-blue-300 text-gray-700"
                  : "text-blue-300 hover:text-blue-500 hover:border-blue-500 hover:bg-gray-100"
              }`}
              disabled={row.active ? true : false}
            >
              {row.name}
            </button>
          ))}
          <button
            onClick={() => dispatch(showCreateForm())}
            className="flex bg-sky-500 text-white rounded-sm py-1 px-2 hover:bg-sky-700 hover:font-semibold"
          >
            <IoIosAddCircle className="ml-1" size={22} />
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="p-4">
        <div className="flex gap-4 mt-8">
          <select
            onChange={(e) => setRecords(e.target.value)}
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
          >
            <option className="p-0 m-0" value={10}>
              10
            </option>
            <option className="p-0 m-0" value={20}>
              20
            </option>
            <option className="p-0 m-0" value={50}>
              50
            </option>
            <option className="p-0 m-0" value={100}>
              100
            </option>
            <option className="p-0 m-0" value={500}>
              500
            </option>
          </select>
          <Select
            placeholder="کتگوری"
            required
            onChange={(e) => setTCategory(e ? e.value : null)}
            isClearable={true}
            options={tCategories}
            styles={{
              control: (provided) => ({
                ...provided,
                padding: "0.2rem", // Adjust the padding value as needed
              }),
            }}
            className="w-40"
          />
          <input
            type="text"
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
            value={search}
            placeholder="جستجو..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <table className="table-auto w-full">
          <thead>
            <tr className="border-y">
              <th className="px-4 py-2 text-start">آی دی</th>
              <th className="px-4 py-2 text-start">کتگوری</th>
              <th className="px-4 py-2 text-start">رنگ</th>
              <th className="px-4 py-2 text-start">تعداد وارده</th>
              <th className="px-4 py-2 text-start">قیمت فی واحد</th>
              <th className="px-4 py-2 text-start">موجودی</th>
              <th className="px-4 py-2 text-start">عملیه ها</th>
            </tr>
          </thead>
          <tbody>
            {materials?.data &&
              materials?.data.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  } border`}
                >
                  <td className="px-4 py-2">{row.id}</td>
                  <td className="px-4 py-2">{row.mname}</td>
                  <td className="px-4 py-2">{row.name}</td>
                  <td className="px-4 py-2">
                    {row.entry_qtys * row.qty_to_unit}{" "}
                  </td>
                  <td className="px-4 py-2">
                    {row.qty_price} {row.currency}
                  </td>
                  <td className="px-4 py-2">
                    {row.exist_qtys} {row.unit}
                  </td>
                  <td className="px-4 py-2">
                    <Options material={row} />{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="flex gap-4 justify-end p-4">
          {materials.links &&
            materials.links.length > 3 &&
            materials.links.map((row, index) => (
              <button
                key={index}
                disabled={row.active || row.url === null}
                onClick={() => setUrl(row.url)}
                className={`border py-1 px-3 ${
                  row.active ? "bg-blue-500 text-white" : "hover:bg-gray-300"
                }`}
              >
                <>{row.label}</>
              </button>
            ))}
          {editObj && <EditMaterial />}
          {deleteItem.id && <Delete />}
        </div>
      </div>
    </div>
  );
}

export default MaterialList;
